//#region DevExtreme Imports

import 'devextreme/ui/accordion'
import 'devextreme/ui/toolbar'

//#endregion

import { IMRAccordionController } from "./accordion.controller"

//#region Asset Imports

import './accordion.scss'
import * as TEMPLATE from './accordion.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrAccordion'

export class IMRAccordionComponent implements ng.IComponentOptions {
    controller = ['$element', '$timeout', IMRAccordionController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

    transclude = true
}
